import "bootstrap/dist/css/bootstrap.min.css";
import { useInbox } from "../../Hooks/layout/useInBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "primereact/dropdown";
import "./Notification.css"

function Inbox(props) {
  const { categories, currentCategory, setCurrentCategory, filterNotification, markAllAsRead, countUnread, sendRemark, remark, setRemark, punctualityData, isRead, setIsRead, reasonList } = useInbox(props)

  return (
    <div style={{ height: "100%" }}>
      <div className='notification-above-text border-bottom'>
        <div className='d-flex gap-2 justify-content-between'>
          <div>
            <h5 className="mb-0">Notifications</h5>
          </div>
          <div className="d-flex gap-2 justify-content-end">
            <span onClick={() => markAllAsRead(null)} className="tab c-pointer">
              <FontAwesomeIcon icon="fa-solid fa-check-double" /> Mark as Read
            </span>
            <span onClick={() => { props?.getNotificationData(); setIsRead(false) }} className={!isRead ? "not-tab c-pointer" : "tab c-pointer"}><FontAwesomeIcon icon="fa-solid fa-envelope" /> New</span>
            <span onClick={() => { props?.getNotificationData(); setIsRead(true) }} className={isRead ? "not-tab c-pointer" : "tab c-pointer"}><FontAwesomeIcon icon="fa-solid fa-envelope-open " /> Read</span>
          </div>
        </div>
      </div>
      {
        props?.dataFlag ?
          <>

            <div className="d-flex gap-2" style={{ height: "90%" }}>
              <div className="p-2 w25" style={{ background: "#eeeded", borderRadius: "10px", height: "100%", overflow: 'auto' }}>
                {categories.map(cat => (
                  <li
                    key={cat}
                    className={`d-flex p-2 mb-1 rounded justify-content-between c-pointer ${currentCategory === cat ? " bg-black text-white" : ""
                      }`}
                    onClick={() => setCurrentCategory(cat)}
                  >
                    {cat}{" "}
                    {countUnread(cat) > 0 && <div className="custom-bagde bg-danger align-self-center mx-1 px-1">
                      <div >{countUnread(cat)}</div>
                    </div>}
                  </li>
                ))}
              </div>
              <div className="w75" style={{ height: "100%", overflow: 'auto' }}>
                {((punctualityData.length > 0 && !isRead) && (currentCategory === "Unpunctual" || currentCategory === "All")) && punctualityData?.map((item) => (
                  <div className="p-2 my-1" style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px" }}>
                    <div className="d-flex justify-content-between">
                      <div className='d-flex gap-2 mt-1'>
                        <div><span className='fw-bold'>Shift Time: </span>{item?.shift_time}</div>
                        <div><span className='fw-bold'>Actual Time: </span>{item?.in_time} - {item?.out_time}</div>
                      </div>
                      <small className="align-content-end" style={{ color: "gray", fontWeight: "600" }}> Unpunctuality Notification</small>
                    </div>
                    <div className="d-flex justify-content-between">
                      <div className="w90">
                        {(item?.is_late_in && !item?.in_remark) ?
                          <div className="d-flex gap-1 mt-2 align-items-end">
                            <div className="w40 mt-2">
                              <Dropdown value={remark[item?.shift_date]?.in_reason_opt || {}} onChange={(e) => setRemark((prev) => ({ ...prev, [item?.shift_date]: { ...prev?.[item?.shift_date], in_reason_opt: e.target?.value } }))} placeholder="Select Late In Reason" options={reasonList} optionLabel="reasons" filter filterInputAutoFocus className=" input-dd" />
                            </div>
                            {remark[item?.shift_date]?.in_reason_opt?.reason_type_key === "other" &&
                              <div className='d-flex mt-2 align-items-center w60'>
                                <input placeholder='Write the unpunctuality remark' value={remark[item?.shift_date]?.in_reason_text || ""} onChange={(e) => setRemark((prev) => ({ ...prev, [item?.shift_date]: { ...prev[item?.shift_date], in_reason_text: e.target?.value } }))} className="w100 input-dd" />
                              </div>
                            }
                            {(!item?.is_early_out || (item?.is_early_out && item?.out_remark) ) ?
                              <div className="mb-1">
                                <button className="sk-btn-confirm-primary-base sk-btn-confirm-info d-inline-flex align-items-center justify-content-center gap-1 py-1 px-3" onClick={() => sendRemark(item)}>
                                  <FontAwesomeIcon icon="fa-solid fa-check" style={{ marginRight: '4px' }} /> Submit
                                </button>
                              </div> : ""
                            }
                          </div> : ""
                        }

                        {(item?.is_early_out && !item?.out_remark) ?
                          <div className="d-flex gap-1 mt-2 align-items-end">
                            <div className="w40 mt-2">
                              <Dropdown value={remark[item?.shift_date]?.out_reason_opt || {}} onChange={(e) => setRemark((prev) => ({ ...prev, [item?.shift_date]: { ...prev?.[item?.shift_date], out_reason_opt: e.target?.value } }))} placeholder="Select Early Out Reason" options={reasonList} optionLabel="reasons" filter filterInputAutoFocus className=" input-dd" />
                            </div>
                            {remark[item?.shift_date]?.out_reason_opt?.reason_type_key === "other" &&
                              <div className='d-flex mt-2 align-items-center w60'>
                                <input placeholder='Write the unpunctuality remark' value={remark[item?.shift_date]?.out_reason_text || ""} onChange={(e) => setRemark((prev) => ({ ...prev, [item?.shift_date]: { ...prev[item?.shift_date], out_reason_text: e.target?.value } }))} className="w100 input-dd" />
                              </div>
                            }
                            <div className="mb-1">
                              <button className="sk-btn-confirm-primary-base sk-btn-confirm-info d-inline-flex align-items-center justify-content-center gap-1 py-1 px-3" onClick={() => sendRemark(item)}>
                                <FontAwesomeIcon icon="fa-solid fa-check" style={{ marginRight: '4px' }} /> Submit
                              </button>
                            </div>
                          </div> : ""
                        }


                      </div>




                      <div className='d-flex justify-content-end w20 mt-2'>
                        <div>
                          <p className="fw-semibold">{item?.shift_date}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {filterNotification?.length > 0 &&
                  filterNotification?.map((val, index) => (
                    <div
                      key={index}
                      className={`p-2 border-bottom ${val?.is_read ? "" : ""}`}
                      onClick={() => { !val?.is_read && markAllAsRead(val.notification_queue_id) }}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex justify-content-between">
                        <div>
                          <div className={`fw-${val?.is_read ? "normal" : "bold"} text-${val?.is_read ? "secondary" : "dark"}`} style={{ fontSize: "14px" }}>
                            {val?.notification_title}
                          </div>
                          <div className="text-muted small">
                            {val?.notification_message}
                          </div>
                        </div>
                        <small className="text-muted align-content-end">{val?.notification_type_name}</small>
                      </div>
                    </div>
                  ))
                }
                {
                  ((filterNotification?.length === 0 && (punctualityData.length === 0 && !isRead)) || (filterNotification?.length === 0 && isRead)) && <div className='notification-loading-container'>
                    <div className="text-center">
                      <img src={"./assets/nodata.jpg"} alt='no data' width={200} height={150} />
                      <p className='text-center red mt-3'> No Notifications Found</p>
                    </div>
                  </div>
                }
              </div>
            </div>
          </> :
          <div className='notification-loading-container'>
            <span>Notifications loading...</span>
          </div>
      }
    </div>
  );
}


export default Inbox;
